module.exports = __webpack_public_path__ + "media/components/assets/logo-87abe3ee137ab9cb6220496f92f1d20f.svg";